<div id="modalWrapper">
    <div class="closeWrapper"><button style="font-size:24px; padding:0 0 0 0; border:none; background-color:white;" (click)="onClose()"><fa-icon icon="times-circle"></fa-icon></button></div>
    <!--<h2 mat-dialog-title class="jumbotron-heading text-center">{{title}}</h2>-->

    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>


        <iframe id="billingFrame" [src]="safeFrameUrlParam" [title]="title"></iframe>


    </mat-dialog-content>

</div>
